import GetUserLang from '../Utils/GetUserLang';
import { setAppLang } from '../Slice';
import { PropsWithChildren, useEffect, useState, useMemo } from 'react';
import { useTranslation } from 'react-i18next';

export default function LangProvider(props: PropsWithChildren<unknown>) {
    const { i18n } = useTranslation();
    const [ready, setReady] = useState(false);
    const l = useMemo(() => GetUserLang(), []);

    useEffect(() => {
        document.documentElement.lang = l;
        setAppLang(l);
        if (i18n.language === l) {
            setReady(true);
            return;
        }
        i18n.changeLanguage(l)
            .catch((error) => {
                console.error('Error changing language:', error);
            }).finally(() => {
                setReady(true);
            });
    }, [i18n, l]);

    if (!ready) return <div>Loading...</div>;
    return <>{props.children}</>;
}
import GetUserLang from '../Utils/GetUserLang';
import { setAppLang } from '../Slice';
import { PropsWithChildren, useEffect, useState, useMemo } from 'react';
import { useTranslation } from 'react-i18next';

export default function LangProvider(props: PropsWithChildren<unknown>) {
    const { i18n } = useTranslation();
    const [ready, setReady] = useState(false);
    const l = useMemo(() => GetUserLang(), []);

    useEffect(() => {
        document.documentElement.lang = l;
        setAppLang(l);
        if (i18n.language === l) {
            setReady(true);
            return;
        }
        i18n.changeLanguage(l)
            .catch((error) => {
                console.error('Error changing language:', error);
            }).finally(() => {
                setReady(true);
            });
    }, [i18n, l]);

    if (!ready) return <div>Loading...</div>;
    return <>{props.children}</>;
}
